module.exports = __webpack_public_path__ + "static/img2-20f6b8515f6405e2fd93cf003c9aee09.jpg";